module.exports = __webpack_public_path__ + "static/media/ruffles-crunch-teen-burger-dt-fr.3b726211.jpg";